import React from 'react';
import Loader from "../UI/Output/Loader/Loader";

import classes from "./Loading.module.scss";

const Loading = () => (
	<div className={classes.loadingPage}>
		<div className={classes.contentHolder}>
			<img alt="Noku Wallet" className={classes.logo} src="https://static.noku.io/assets/noku/logo_white.svg" />
			<span className={classes.loading}>
				<Loader className={classes.loader} />
			</span>
		</div>
	</div>
);

export default Loading;